var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtsSettings = function SvgAtsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13h5v-1H8zm0 2h3v-1H8zm7 0h3v-1h-3zm7 5h-4v-1h.5a.5.5 0 1 0 0-1h-2a.5.5 0 1 0 0 1h.5v1h-6v-1h.5a.5.5 0 1 0 0-1h-2a.5.5 0 1 0 0 1h.5v1H6V8h16zm0-13H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1M8 11h5v-1H8zm12-7c0-.552.052-1-.5-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1V4h18m2 2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1V6h18m-7 5h5v-1h-5zm0 2h5v-1h-5z"
  })));
};
export default SvgAtsSettings;